import type { SportProfile } from '@/types'

export const fieldHockey: SportProfile = {
  id: 'field-hockey',
  sport: 'field-hockey',
  gender: 'womens',
  environment: 'outdoor',
  label: 'Field Hockey',
  emoji: '🏑',
  playersOnField: 11,
  contactLevel: 'limited',
  hasShotClock: false,
  periods: { label: 'Quarter', count: 4, durationMinutes: 15 },
  positions: [
    { key: 'goalkeeper', label: 'Goalkeeper', shortLabel: 'GK', maxOnField: 1 },
    { key: 'defender',   label: 'Defender',   shortLabel: 'DEF' },
    { key: 'midfielder', label: 'Midfielder',  shortLabel: 'MID' },
    { key: 'forward',    label: 'Forward',     shortLabel: 'FWD' },
  ],
  stats: [
    { key: 'goal',            label: 'Goal',               shortLabel: 'G'   },
    { key: 'assist',          label: 'Assist',              shortLabel: 'A'   },
    { key: 'shot',            label: 'Shot',                shortLabel: 'SH'  },
    { key: 'shot_on_goal',    label: 'Shot on Goal',        shortLabel: 'SOG' },
    { key: 'save',            label: 'Save',                shortLabel: 'SV'  },
    { key: 'penalty_corner',  label: 'Penalty Corner',      shortLabel: 'PC'  },
    { key: 'penalty_stroke',  label: 'Penalty Stroke',      shortLabel: 'PS'  },
    { key: 'green_card',      label: 'Green Card (Warning)',shortLabel: 'GC', statType: 'card' },
    { key: 'yellow_card',     label: 'Yellow Card',         shortLabel: 'YC', statType: 'card' },
    { key: 'red_card',        label: 'Red Card',            shortLabel: 'RC', statType: 'card' },
    { key: 'turnover',        label: 'Turnover',            shortLabel: 'TOV' },
    { key: 'opp_shot',        label: 'Opp Shot',            shortLabel: 'OPP', statType: 'opp-shot' },
  ],
}
